const ppcServicesData = [
  {
    title: "Account Setup",
    description:
      "Install pixels, define UTMs, and set up a clean account/campaign structure aligned to goals.",
    bullets: ["Pixels", "UTMs", "Structure", "Budgets"],
    minHeight: 400,
  },
  {
    title: "Campaigns",
    description:
      "Build and manage search, display, and social campaigns tailored to funnel stages and audiences.",
    bullets: ["Search", "Display", "Social", "Video"],
    minHeight: 400,
  },
  {
    title: "Creatives",
    description:
      "Craft persuasive ad copy and assets with variant testing, localization, and compliance checks.",
    bullets: ["Copy", "Design", "Variants", "Localization"],
    minHeight: 400,
  },
  {
    title: "Optimization",
    description:
      "Iterative optimizations across bids, audiences, negatives, and budget reallocation for ROAS/CPA goals.",
    bullets: ["Bidding", "Audiences", "Exclusions", "Budget Shift"],
    minHeight: 400,
  },
  {
    title: "Landing Pages",
    description:
      "Design high‑converting landing pages with speed, clarity, and A/B tests to improve conversion rate.",
    bullets: ["LPs", "A/B", "Speed", "Forms"],
    minHeight: 400,
  },
  {
    title: "Reporting",
    description:
      "Clear performance dashboards with attribution, cohort views, and actionable weekly insights.",
    bullets: ["KPIs", "ROI", "Attribution", "Reports"],
    minHeight: 400,
  },
  {
    title: "Feed Management",
    description:
      "Create and maintain structured product feeds, fix diagnostics, and ensure schema health across channels.",
    bullets: ["Feeds", "Diagnostics", "Schema", "Sync"],
    minHeight: 400,
  },
  {
    title: "Experimentation",
    description:
      "Run A/B and bandit experiments with rigorous hypotheses, guardrails, and clear readouts.",
    bullets: ["A/B", "Bandit", "Hypotheses", "Readouts"],
    minHeight: 400,
  },
  {
    title: "Budget Planning",
    description:
      "Plan budgets with pacing, seasonal curves, LTV insights, and portfolio strategies by channel.",
    bullets: ["Pacing", "Seasonality", "LTV", "Portfolio"],
    minHeight: 400,
  },
];

export default ppcServicesData;
